import {
  GET_ROTATION_SLOTS,
  GET_ROTATION_SLOTS_COMPLETED,
  GET_ROTATION_SLOTS_FAILED,
} from "./actions";

const initialState = {
  data: [],
  isLoading: false,
  isInitialized: false,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROTATION_SLOTS:
      return { ...state, isLoading: true };
    case GET_ROTATION_SLOTS_COMPLETED:
      return {
        ...state,
        data: Array.isArray(action.payload.result) ? action.payload.result : [],
        isLoading: false,
        isInitialized: true,
      };
    case GET_ROTATION_SLOTS_FAILED:
      return { ...state, isLoading: false, isInitialized: true };
    default:
      return state;
  }
};

export default reducers;
